import type { Wallet } from '@/types/auth';

/** Human-readable wallet label: custom label, short address, or truncated address. */
export function walletDisplayLabel(wallet: Wallet): string {
  if (wallet.label) return wallet.label;
  if (wallet.address.length <= 12) return wallet.address;
  return `${wallet.address.slice(0, 6)}...${wallet.address.slice(-4)}`;
}
